import React from 'react'
import './app.css';
import './css/root.css'
import 'react-datepicker/dist/react-datepicker.css'
import './css/react-transition.css'
import './css/bootstrap-override.css'
import './css/sidebar.css'
import './css/font-awesome-customize.css'
import './css/custom-styling.css'
import Main from './components/main'
import Sidebar from './components/sidebar'
// import Navbar from './components/navbar'
import { connect } from 'react-redux'
import { withRouter, Redirect } from 'react-router-dom'
import sidebars from './config'
import { EYM_TKN_OBJ, EYM_USR } from './actions/constants'
import { changeAuth, getUserData, logout } from './actions/auth'
import NavbarAlternate from './components/NavbarAlternate';


const App = ({ auth, dispatch, location, history }) => {
    /*
    if( location.pathname[ location.pathname.length - 1 ] === '/' ){
        // if the last character of the url is a slash, remove it
        history.push(location.pathname.slice(0, location.pathname.length -1))
    }
    */
    if (auth.authenticated && auth.user === null) {
        let lstg = window.localStorage
        let sstg = window.sessionStorage

        let user = lstg.getItem(EYM_USR) || sstg.getItem(EYM_USR) || null
        if (user) {
            dispatch(changeAuth({
                user: JSON.parse(user)
            }))
        } else {
            let accessTknObjStr = lstg.getItem(EYM_TKN_OBJ) || sstg.getItem(EYM_TKN_OBJ) || null
            let accessTknObj = accessTknObjStr ? JSON.parse(accessTknObjStr) : null
            if (accessTknObjStr && accessTknObj.userId && accessTknObj.id) {
                dispatch(getUserData(accessTknObj.userId, accessTknObj.id, true))
            } else {
                dispatch(logout(auth.access_token))
            }
        }
    }

    return (
        auth.authenticated ?
            <div id="app-wrapper">
                <NavbarAlternate sidebars={sidebars} />
                <Sidebar />
                <div className="content-wrapper">
                    <Main />

                </div>
            </div> :
            <Redirect to='/' />
    )
}

function mapStateToProps(state) {
    return {
        auth: state.auth
    }
}

export default withRouter(connect(mapStateToProps)(App))


// WEBPACK FOOTER //
// ./src/app.js